import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import i18next from "i18next";
import { I18nextProvider, initReactI18next } from "react-i18next";
import i18n from "i18next";
import Logo from "./components/assets/redLogo-removebg-preview.png";

const languages = ["en", "pt", "fr"];

const resources = {};
const loadLanguageResources = () => {
  const promises = languages.map((language) =>
    import(`./translations/${language}/global.json`).then((translation) => {
      resources[language] = { translation: translation.default };
    })
  );
  return Promise.all(promises);
};

const LanguageLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLanguageResources().then(() => {
      i18n.use(initReactI18next).init({
        resources,
        lng: "pt",
        fallbackLng: "pt",
        interpolation: {
          escapeValue: false,
        },
      });
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center m-auto ">
        <img className="animate-ping" src={Logo} alt="logo jumping" />
      </div>
    );
  }

  return (
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <LanguageLoader />
  </React.StrictMode>
);
